module.exports = __webpack_public_path__ + "static/media/geraldo_jose_lombardi_de_souza.a1128eb1.jpg";